var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceLogoPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "source_logo_placeholder_svg__a",
    x: 0,
    y: 0,
    width: 28.127,
    height: 28,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.5V23a1 1 0 01-1 1h-9a1 1 0 01-1-1v-2.5h11zm-3.5 1h-4a.5.5 0 100 1h4a.5.5 0 100-1zm3.5-14V20h-11V7.5h11zm-1-3.5a1 1 0 011 1v2h-11V5a1 1 0 011-1h9z",
    id: "source_logo_placeholder_svg__b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    xlinkHref: "#source_logo_placeholder_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#source_logo_placeholder_svg__b"
  }))));
}
export default SvgSourceLogoPlaceholder;